<template>
  <v-card class="ui-module-card ui-module-fade-in-up personal-armamento-shell" color="primary">
    <v-card-text>
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <v-row align="center" justify="end" class="mx-0 toolbar-row">
              <v-col cols="12" class="d-flex justify-end">
                <div class="toolbar-actions">
                  <div class="search-wrap">
                    <BaseInput v-model="search" label="Buscar" append-icon="mdi-magnify" class="search-input" />
                  </div>
                  <div class="download-action d-flex align-center justify-center">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          <IconButton variant="secondary" icon="mdi-download" @click="downloadPersonalCsv" />
                        </span>
                      </template>
                      <span>Descargar CSV</span>
                    </v-tooltip>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card class="ui-module-card" color="primary" :loading="loading">
              <v-card-text>
                <v-data-table :headers="headers" :items="filteredPersonal" class="transparent armory-table">
                  <template v-slot:[`item.nombre`]="{ item }">
                    {{ item.nombreCompleto }}
                  </template>
                  <template v-slot:[`item.puesto`]="{ item }">
                    {{ item.puesto ? item.puesto : '' }}
                  </template>
                  <template v-slot:[`item.CUP`]="{ item }">
                    <span>
                      {{ item.CUP ? item.CUP : 'Sin datos' }}
                    </span>
                  </template>
                  <template v-slot:[`item.opciones`]="{ item }">
                    <span class="d-flex align-center action-group">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <IconButton
                              class="mr-2"
                              variant="secondary"
                              elevation="8"
                              icon="mdi-card-account-details-outline"
                              :to="{
                                path: 'documentos_personal/' + item.id_personal,
                                params: { id: item.id_personal },
                              }"
                            />
                          </span>
                        </template>
                        <span>Ver expediente</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <IconButton
                              class="mr-2"
                              variant="secondary"
                              elevation="8"
                              icon="mdi-delete-alert-outline"
                              @click="openRemoverLocDialog(item)"
                            />
                          </span>
                        </template>
                        <span>Eliminar personal LOC</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <IconButton
                              class="mr-2"
                              elevation="8"
                              variant="secondary"
                              icon="mdi-file-word"
                              @click="generarConstanciaNoAdeudo(item)"
                            />
                          </span>
                        </template>
                        <span>Constancia de No Adeudo</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <IconButton
                              class="mr-2"
                              elevation="8"
                              variant="secondary"
                              icon="mdi-file-word-outline"
                              @click="generarResguardoArmamentoMuniciones(item)"
                            />
                          </span>
                        </template>
                        <span>Constancia de Resguardo</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" class="fatiga-trigger">
                            <IconButton
                              elevation="8"
                              class="mr-2"
                              variant="secondary"
                              icon="mdi-format-list-checks"
                              :to="{ name: 'paseListaDiario', query: { idPersonal: item.id_personal } }"
                            />
                          </span>
                        </template>
                        <span>Fatiga entrega/recepción</span>
                      </v-tooltip>
                    </span>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { Packer } from 'docx'
import IconButton from '../../base/IconButton.vue'
import BaseInput from '../../base/BaseInput.vue'
import TextButton from '../../base/TextButton.vue'
import moment from 'moment'
import downloadCsv from '@/utils/downloadCsv'
import ConstanciaNoAdeudoArmeria from '@/utils/doc-generator/armeria/ConstanciaNoAdeudo.js'
import ResguardoArmamentoMuniciones from '@/utils/doc-generator/armeria/ResguardoArmamentoMuniciones.js'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { DIALOG_TYPES } from '@/plugins/dialog-types'

export default {
  components: {
    IconButton,
    BaseInput,
    TextButton,
  },

  data() {
    return {
      headers: [
        { text: 'Nombre', value: 'nombre', width: '250px' },
        { text: 'Puesto', value: 'puesto', width: '200px' },
        { text: 'CUIP', value: 'CUIP', width: '150px' },
        { text: 'CUP', value: 'CUP', width: '100px' },
        { text: 'Opciones', value: 'opciones', sortable: false, width: '200px' },
      ],
      loading: false,
      search: '',
      mostrarConstancia: false,
      resguardoArmamentoMuniciones: false,
      DIALOG_TYPES,
    }
  },

  computed: {
    ...mapGetters('armeria', {
      personalOriginal: 'getPersonalArmas',
    }),
    ...mapGetters('armaPersonal', {
      armas: 'getArmasPersonal',
    }),
    filteredPersonal() {
      const term = (this.search || '').trim().toLowerCase()
      const items = this.personalOriginal || []
      if (!term) return items
      return items.filter((p) => {
        const nombre = (p.nombreCompleto || '').toLowerCase()
        const puesto = (p.puesto || '').toLowerCase()
        const cuip = (p.CUIP || '').toLowerCase()
        const cup = (p.CUP || '').toLowerCase()
        return nombre.includes(term) || puesto.includes(term) || cuip.includes(term) || cup.includes(term)
      })
    },
  },

  methods: {
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapActions('armeria', ['removePersonalLoc']),
    ...mapActions('armaPersonal', ['fetchArmasPersonal']),

    openRemoverLocDialog(item) {
      this.SET_DIALOG({
        ...this.DIALOG_TYPES.CONFIRMACION_REMOVER_PERSONAL_LOC,
        props: {
          idPersonal: item.id_personal,
          idPersonalLoc: item.idPersonalLoc,
          onConfirm: () => this.confirmRemoveLoc(item),
        },
      })
    },

    async confirmRemoveLoc(item) {
      await this.removePersonalLoc({
        idPersonal: item.id_personal,
        idPersonalLoc: item.idPersonalLoc,
        payload: {},
      })
      this.$store.dispatch('armeria/fetchPersonalArmas')
      this.$store.dispatch('dialog/closeDialog')
    },

    async generarConstanciaNoAdeudo(personal) {
      const area = personal.nombreDependencia && personal.nombreDependencia ? personal.nombreDependencia : ''
      const doc = new ConstanciaNoAdeudoArmeria({
        nombre: personal.nombreCompleto,
        area: area,
      })
      const newDoc = await doc.generate()
      const blob = await Packer.toBlob(newDoc)
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `ConstanciaNoAdeudo_${personal.nombreCompleto}.docx`
      a.click()
      window.URL.revokeObjectURL(url)
    },

    async generarResguardoArmamentoMuniciones(personal) {
      await this.fetchArmasPersonal(personal.id_personal)
      const fechaHoy = moment().format('YYYY-MM-DD')
      const doc = new ResguardoArmamentoMuniciones({
        nombre: personal.nombreCompleto,
        cuip: personal.CUIP || '',
        fecha: fechaHoy,
        armas: this.armas.map((arma) => arma.Arma),
      })
      const newDoc = await doc.generate()
      const blob = await Packer.toBlob(newDoc)
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `ResguardoArmamentoMuniciones_${personal.nombreCompleto}.docx`
      a.click()
      window.URL.revokeObjectURL(url)
    },

    downloadPersonalCsv() {
      const rows = (this.filteredPersonal || []).map((item) => ({
        Nombre: item.nombreCompleto || '',
        Puesto: item.puesto || '',
        CUIP: item.CUIP || '',
        CUP: item.CUP || 'Sin datos',
      }))

      downloadCsv(rows, { filename: 'personal-armamento' })
    },
  },
  created() {
    this.$store.dispatch('armeria/fetchPersonalArmas')
  },
}
</script>

<style scoped>
/* Estilos modernos para PersonalArmamento */
.personal-armamento-shell {
  min-height: calc(100vh - 64px);
  min-height: calc(100dvh - 64px);
}

.ui-module-card {
  background: rgba(30, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(108, 92, 231, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

/* Títulos */
.v-card-title {
  color: #e0e0e0 !important;
  border-bottom: 1px solid rgba(108, 92, 231, 0.2);
}

.text-h5 {
  color: #e0e0e0 !important;
}

/* Tabla */
::v-deep .v-data-table {
  background: transparent !important;
  color: #e0e0e0 !important;
}

::v-deep .v-data-table-header {
  background: rgba(108, 92, 231, 0.15) !important;
}

::v-deep .v-data-table-header th {
  color: #e0e0e0 !important;
  font-weight: 600 !important;
  border-bottom: 2px solid rgba(108, 92, 231, 0.3) !important;
}

::v-deep .v-data-table tbody tr {
  transition: all 0.3s ease;
}

::v-deep .v-data-table tbody tr:hover {
  background: rgba(108, 92, 231, 0.1) !important;
}

::v-deep .v-data-table tbody td {
  color: #e0e0e0 !important;
  border-bottom: 1px solid rgba(108, 92, 231, 0.1) !important;
}

.action-group {
  gap: 4px;
}

::v-deep .action-group .v-btn {
  border: 1px solid rgba(108, 92, 231, 0.25) !important;
  background: rgba(108, 92, 231, 0.08) !important;
}

::v-deep .fatiga-trigger .v-btn {
  border-color: rgba(108, 92, 231, 0.6) !important;
  background: linear-gradient(135deg, rgba(108, 92, 231, 0.22) 0%, rgba(26, 5, 163, 0.3) 100%) !important;
  box-shadow: 0 4px 16px rgba(26, 5, 163, 0.3) !important;
}

::v-deep .fatiga-trigger .v-btn .v-icon {
  color: #b4a9ff !important;
}

::v-deep .search-input .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(108, 92, 231, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
}

::v-deep .search-input .v-input__slot:hover {
  border-color: rgba(108, 92, 231, 0.45) !important;
}

::v-deep .search-input .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .search-input.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .search-input .v-input__slot input {
  color: #e0e0e0 !important;
}

::v-deep .search-input .v-text-field__details {
  display: none !important;
}

::v-deep .search-input {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

::v-deep .search-input .v-label,
::v-deep .search-input .mdi-magnify {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .search-input.v-input--is-focused .v-label {
  color: #a29bfe !important;
}

.toolbar-row {
  row-gap: 8px;
}

.toolbar-actions {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 8px;
  width: 100%;
}

.search-wrap {
  width: min(320px, 100%);
  display: flex;
  align-items: flex-start;
}

.download-action {
  min-height: 40px;
  flex: 0 0 auto;
  padding-top: 2px;
}

@media (max-width: 600px) {
  .toolbar-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .search-wrap {
    width: 100%;
  }
}

/* Botones */
::v-deep .v-btn {
  border-radius: 12px;
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(108, 92, 231, 0.3);
}

/* Iconos */
::v-deep .v-icon {
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  color: #6c5ce7 !important;
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(30, 30, 46, 0.95) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(108, 92, 231, 0.3);
  border-radius: 8px;
  color: #e0e0e0 !important;
}

/* ==================== DATA FOOTER ==================== */
::v-deep .v-data-footer {
  background: rgba(18, 18, 18, 0.5) !important;
  border-top: 1px solid rgba(108, 92, 231, 0.2) !important;
}

::v-deep .v-data-footer__select .v-select {
  color: #e0e0e0 !important;
}

/* ==================== SCROLLBAR ==================== */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(108, 92, 231, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(108, 92, 231, 0.6);
}
</style>
